// extracted by mini-css-extract-plugin
export default {"tab-panel":"TabPanel_tab-panel__G-4q3"};